/* Pazarium ana sayfa: koleksiyon sekmeleri, hero slider, renk trendleri */
(() => {
  if (window.PZHome) return;
  window.PZHome = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TAB_KEY = 'pz-tab';
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch {} },
  };

  /* ---------- Koleksiyon sekmeleri ---------- */
  let currentTab = '1';
  const sliders = new Set();

  function applyTab(n) {
    const tabs = document.querySelector('[data-pz-tabs]');
    // Sayfada sekme section'ı yoksa her şey görünür
    currentTab = tabs ? String(n) : 'all';
    document.querySelectorAll('[data-pz-show]').forEach(el => {
      const v = el.dataset.pzShow;
      el.hidden = !(currentTab === 'all' || v === 'all' || v === currentTab);
    });
    document.querySelectorAll('[data-pz-tab]').forEach(b => b.setAttribute('aria-selected', b.dataset.pzTab === currentTab));
    document.documentElement.classList.add('pz-ready');
    positionPill();
    sliders.forEach(s => s.refresh());
  }

  /* Seçili sekmenin arkasındaki hapı kaydır; ilk konumlandırma animasyonsuz */
  function positionPill() {
    const seg = document.querySelector('[data-pz-tabs] .pz-seg');
    const pill = seg && seg.querySelector('.pz-seg__pill');
    const btn = seg && seg.querySelector('[aria-selected="true"]');
    if (!pill || !btn || !btn.offsetWidth) return;
    const first = !seg.classList.contains('is-ready');
    if (first || reduced) seg.classList.add('no-anim');
    pill.style.width = btn.offsetWidth + 'px';
    pill.style.transform = `translateX(${btn.offsetLeft}px)`;
    if (first) {
      seg.classList.add('is-ready');
      requestAnimationFrame(() => requestAnimationFrame(() => { if (!reduced) seg.classList.remove('no-anim'); }));
    }
  }
  addEventListener('resize', () => {
    const seg = document.querySelector('[data-pz-tabs] .pz-seg');
    if (seg) seg.classList.add('no-anim');
    positionPill();
    requestAnimationFrame(() => { if (seg && !reduced) seg.classList.remove('no-anim'); });
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => positionPill());

  /* Sticky sekme çubuğu: temanın header'ı görünür olduğu sürece onun hemen altına yapışır */
  let stickyTicking = false;
  function updateSticky() {
    stickyTicking = false;
    const tabs = document.querySelector('[data-pz-tabs].pz-tabs--sticky');
    const wrap = tabs && tabs.closest('.shopify-section');
    if (!wrap) return;
    const header = document.querySelector('header-component') || document.querySelector('[id$="__header_section"]') || document.querySelector('.shopify-section-group-header-group');
    let top = 0;
    if (header) {
      const r = header.getBoundingClientRect();
      if (r.height && r.bottom > 0) top = Math.round(r.bottom);
    }
    wrap.style.setProperty('--pz-sticky-top', top + 'px');
    tabs.classList.toggle('is-stuck', scrollY > 0 && wrap.getBoundingClientRect().top <= top + 1);
  }
  const requestSticky = () => { if (!stickyTicking) { stickyTicking = true; requestAnimationFrame(updateSticky); } };
  addEventListener('scroll', requestSticky, { passive: true });
  addEventListener('resize', requestSticky);

  const designMode = !!(window.Shopify && Shopify.designMode);
  // Adres senkronu tema editöründe kapalı (editör önizlemesinin adresi değişmesin)
  const syncOn = tabs => tabs && tabs.dataset.sync === 'true' && !designMode && history.pushState;

  function initTabs() {
    const tabs = document.querySelector('[data-pz-tabs]');
    // Açılış sekmesini section içindeki satır içi script belirledi
    let start = document.documentElement.getAttribute('data-pz-active') || '1';
    if (tabs && !tabs.querySelector(`[data-pz-tab="${start}"]`)) start = '1';
    applyTab(start);
    if (syncOn(tabs)) history.replaceState(Object.assign({}, history.state, { pzTab: start }), '');
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-pz-tab]');
    if (!btn) return;
    const tabs = btn.closest('[data-pz-tabs]');
    const n = btn.dataset.pzTab;
    if (n === currentTab) return;
    applyTab(n);
    if (syncOn(tabs) && btn.dataset.url) {
      history.pushState({ pzTab: n }, '', btn.dataset.url);
      if (btn.dataset.title) document.title = btn.dataset.title;
    } else if (tabs && tabs.dataset.remember === 'true') {
      store.set(TAB_KEY, n);
    }
  });

  // Geri/ileri tuşu: adrese göre sekmeyi geri getir
  window.addEventListener('popstate', e => {
    const tabs = document.querySelector('[data-pz-tabs]');
    if (!syncOn(tabs)) return;
    let n = e.state && e.state.pzTab;
    if (!n) {
      const btn = [...tabs.querySelectorAll('[data-pz-tab]')].find(b => b.dataset.url && new URL(b.dataset.url, location.origin).pathname === location.pathname);
      n = btn ? btn.dataset.pzTab : tabs.dataset.home || '1';
    }
    applyTab(n);
    const btn = tabs.querySelector(`[data-pz-tab="${n}"]`);
    if (btn && btn.dataset.title) document.title = btn.dataset.title;
  });

  /* ---------- Hero slider (story tarzı ilerleme çubukları) ---------- */
  class Slider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-pz-track]');
      this.bars = el.querySelector('[data-pz-bars]');
      this.ms = (Number(el.dataset.speed) || 5) * 1000;
      this.autoplay = el.dataset.autoplay === 'true' && !reduced;
      this.idx = 0; this.start = performance.now(); this.last = this.start;
      this.visible = true; this.held = false; this.dead = false;
      this.io = new IntersectionObserver(([en]) => { this.visible = en.isIntersecting; });
      this.io.observe(el);
      let t;
      this.track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
          if (i !== this.idx) { this.idx = i; this.start = performance.now(); }
        }, 120);
      }, { passive: true });
      el.addEventListener('pointerdown', () => { this.held = true; });
      el.addEventListener('pointerup', () => { this.held = false; });
      el.addEventListener('pointercancel', () => { this.held = false; });
      this.refresh();
      this.loop = this.loop.bind(this);
      requestAnimationFrame(this.loop);
    }
    slides() { return [...this.track.children].filter(s => !s.hidden); }
    refresh() {
      const n = this.slides().length;
      this.bars.innerHTML = n > 1 ? '<i><b></b></i>'.repeat(n) : '';
      this.idx = 0; this.track.scrollLeft = 0; this.start = performance.now();
    }
    go(i) {
      const n = this.slides().length;
      if (!n) return;
      this.idx = (i + n) % n;
      this.track.scrollTo({ left: this.idx * this.track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      this.start = performance.now();
    }
    goToSlide(slideEl) {
      const i = this.slides().indexOf(slideEl);
      if (i >= 0) this.go(i);
    }
    loop(t) {
      if (this.dead) return;
      const dt = t - this.last; this.last = t;
      // Ekranda değilken, sekme arka plandayken veya parmakla tutulurken süre durur
      if (this.held || !this.visible || document.hidden) this.start += dt;
      const n = this.slides().length;
      const p = Math.min(1, (t - this.start) / this.ms);
      this.bars.querySelectorAll('b').forEach((b, i) => { b.style.width = (i < this.idx ? 100 : i === this.idx ? p * 100 : 0) + '%'; });
      if (this.autoplay && n > 1 && p >= 1) this.go(this.idx + 1);
      requestAnimationFrame(this.loop);
    }
    destroy() { this.dead = true; this.io.disconnect(); }
  }

  function initSliders(scope = document) {
    scope.querySelectorAll('[data-pz-slider]').forEach(el => {
      if (el.pzSlider) return;
      el.pzSlider = new Slider(el);
      sliders.add(el.pzSlider);
    });
  }

  /* ---------- Renk trendleri ---------- */
  document.addEventListener('click', e => {
    const sw = e.target.closest('[data-pz-swatch]');
    if (!sw) return;
    const sec = sw.closest('[data-pz-colors]');
    sec.querySelectorAll('[data-pz-swatch]').forEach(b => b.setAttribute('aria-pressed', b === sw));
    sec.querySelectorAll('[data-pz-color-panel]').forEach(p => { p.hidden = p.dataset.pzColorPanel !== sw.dataset.pzSwatch; });
  });

  /* ---------- Başlat + tema editörü olayları ---------- */
  function init() { initSliders(); initTabs(); updateSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', e => { initSliders(e.target); applyTab(currentTab); updateSticky(); });
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-pz-slider]').forEach(el => { if (el.pzSlider) { el.pzSlider.destroy(); sliders.delete(el.pzSlider); } });
  });
  // Editörde başka sekmeye ait bir section/blok seçilince o sekmeye geç
  const reveal = target => {
    const own = target.closest('[data-pz-show]') || target.querySelector('[data-pz-show]');
    const v = own && own.dataset.pzShow;
    if (v && v !== 'all' && v !== currentTab && document.querySelector('[data-pz-tabs]')) applyTab(v);
  };
  document.addEventListener('shopify:section:select', e => reveal(e.target));
  document.addEventListener('shopify:block:select', e => {
    reveal(e.target);
    const slider = e.target.closest('[data-pz-slider]');
    if (slider && slider.pzSlider) { slider.pzSlider.held = true; slider.pzSlider.goToSlide(e.target); }
  });
  document.addEventListener('shopify:block:deselect', e => {
    const slider = e.target.closest('[data-pz-slider]');
    if (slider && slider.pzSlider) slider.pzSlider.held = false;
  });
})();
